<template>
  <div>
    <b-row>
      <b-col md="6">
        <b-form-group label-for="nomor-kkprl">
          <template #label>Nomor KKPRL <span class="text-danger">*</span></template>
          <b-form-input
            id="nomor-kkprl"
            :value="value.nomor_kkprl"
            type="text"
            @input="updateField('nomor_kkprl', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="npwp">
          <template #label>NPWP <span class="text-danger">*</span></template>
          <b-form-input
            id="npwp"
            :value="value.npwp"
            type="text"
            v-mask="'##.###.###.#-###.####'"
            @input="updateField('npwp', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="subjek-hukum">
          <template #label>Subjek Hukum <span class="text-danger">*</span></template>
          <b-form-input
            id="subjek-hukum"
            :value="value.subjek_hukum"
            type="text"
            @input="updateField('subjek_hukum', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="nib">
          <template #label>NIB <span class="text-danger">*</span></template>
          <b-form-input id="nib" :value="value.nib" type="text" @input="updateField('nib', $event)" />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="provinsi">
          <template #label>Provinsi <span class="text-danger">*</span></template>
          <v-select
            id="provinsi"
            :value="value.provinsi"
            :options="provinsiOptions"
            :reduce="(provinsi) => provinsi.nama_provinsi"
            label="nama_provinsi"
            placeholder="Pilih Provinsi"
            :disabled="isLoadingProvinsi"
            @input="updateField('provinsi', $event)"
          />
          <small v-if="isLoadingProvinsi" class="text-muted">Memuat daftar provinsi...</small>
          <small v-else-if="provinsiError" class="text-danger">{{ provinsiError }}</small>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="tanggal-terbit">
          <template #label>Tanggal Terbit <span class="text-danger">*</span></template>
          <b-form-input
            id="tanggal-terbit"
            :value="value.tanggal_terbit"
            type="date"
            @input="updateField('tanggal_terbit', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="nama-kegiatan">
          <template #label>Nama Kegiatan <span class="text-danger">*</span></template>
          <b-form-input
            id="nama-kegiatan"
            :value="value.nama_kegiatan"
            type="text"
            @input="updateField('nama_kegiatan', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="nama-detail-kegiatan">
          <template #label>Nama Detail Kegiatan <span class="text-danger">*</span></template>
          <b-form-input
            id="nama-detail-kegiatan"
            :value="value.nama_detail_kegiatan"
            type="text"
            @input="updateField('nama_detail_kegiatan', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="luas">
          <template #label>Luas <span class="text-danger">*</span></template>
          <b-input-group append="ha">
            <b-form-input id="luas" :value="value.luas" type="text" @input="updateField('luas', $event)" />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="panjang">
          <template #label>Panjang <span class="text-danger">*</span></template>
          <b-input-group append="m">
            <b-form-input id="panjang" :value="value.panjang" type="text" @input="updateField('panjang', $event)" />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="nama-perairan">
          <template #label>Nama Perairan <span class="text-danger">*</span></template>
          <b-form-input
            id="nama-perairan"
            :value="value.nama_perairan"
            type="text"
            @input="updateField('nama_perairan', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="nama-kawasan-rtr">
          <template #label>Nama Kawasan RTR <span class="text-danger">*</span></template>
          <b-form-input
            id="nama-kawasan-rtr"
            :value="value.nama_kawasan_rtr"
            type="text"
            @input="updateField('nama_kawasan_rtr', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="dasar-hukum-rtr">
          <template #label>Dasar Hukum RTR <span class="text-danger">*</span></template>
          <b-form-input
            id="dasar-hukum-rtr"
            :value="value.dasar_hukum_rtr"
            type="text"
            @input="updateField('dasar_hukum_rtr', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="realisasi-pemanfaatan">
          <template #label>Realisasi Pemanfaatan Ruang Laut <span class="text-danger">*</span></template>
          <b-form-input
            id="realisasi-pemanfaatan"
            :value="value.realisasi_pemanfaatan_ruang_laut"
            type="text"
            @input="updateField('realisasi_pemanfaatan_ruang_laut', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="keterangan-realisasi">
          <template #label>Keterangan Realisasi <span class="text-danger">*</span></template>
          <b-form-input
            id="keterangan-realisasi"
            :value="value.keterangan_realisasi"
            type="text"
            @input="updateField('keterangan_realisasi', $event)"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label-for="bukti-dukung">
          <template #label>Bukti Dukung (PDF) <span class="text-danger">*</span></template>
          <b-form-file
            id="bukti-dukung"
            :value="value.bukti_dukung"
            accept=".pdf,application/pdf"
            placeholder="Pilih file PDF"
            drop-placeholder="Letakkan file PDF di sini"
            plain
            class="form-control"
            @input="updateField('bukti_dukung', $event)"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <div class="d-flex align-items-center justify-content-between mb-2 mt-4">
      <h5 class="mb-0">Titik Koordinat <span class="text-danger">*</span></h5>
      <div>
        <b-button size="sm" variant="info" class="mr-2" @click="showImportModal = true">
          <i class="fa fa-upload"></i> Import
        </b-button>
        <b-button size="sm" variant="primary" @click="tambahTitik"> <i class="fa fa-plus"></i> Tambah Titik </b-button>
      </div>
    </div>

    <div class="table-responsive mb-0 datatables">
      <b-table
        striped
        hover
        :items="itemsWithNumber"
        :fields="fields"
        responsive="sm"
        show-empty
        empty-text="Belum ada titik koordinat."
      >
        <template #head(bujur)> Bujur <span class="text-danger">*</span> </template>
        <template #head(lintang)> Lintang <span class="text-danger">*</span> </template>
        <template #head(observasi)> Observasi Titik Pengendalian <span class="text-danger">*</span> </template>
        <template #cell(bujur)="data">
          <b-form-input
            :value="data.item.bujur"
            type="text"
            :aria-label="`Bujur titik ${data.item.nomor}`"
            @input="updatePoint(data.item.id, 'bujur', $event)"
          />
        </template>
        <template #cell(lintang)="data">
          <b-form-input
            :value="data.item.lintang"
            type="text"
            :aria-label="`Lintang titik ${data.item.nomor}`"
            @input="updatePoint(data.item.id, 'lintang', $event)"
          />
        </template>
        <template #cell(observasi)="data">
          <b-form-radio-group
            :id="`observasi-${data.item.id}`"
            :checked="data.item.observasi"
            :options="observasiOptions"
            :name="`observasi-${data.item.id}`"
            @input="updatePoint(data.item.id, 'observasi', $event)"
          />
        </template>
        <template #cell(aksi)="data">
          <b-button size="sm" variant="danger" @click="hapusTitik(data.item.id)">
            <i class="fa fa-trash"></i> Hapus
          </b-button>
        </template>
      </b-table>
    </div>

    <b-modal v-model="showImportModal" title="Import Titik Koordinat" hide-footer @hidden="resetImport" scrollable>
      <template>
        <b-form-group label-for="import-koordinat-file">
          <template #label>File Excel <span class="text-danger">*</span></template>
          <b-form-file
            id="import-koordinat-file"
            v-model="importFile"
            accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            placeholder="Pilih file Excel"
            drop-placeholder="Letakkan file Excel di sini"
            plain
            class="form-control"
          />
        </b-form-group>
        <a class="btn btn-outline-primary btn-sm mb-3" href="/template/format_import_titik_koordinat.xlsx" download>
          <i class="fa fa-download"></i> Unduh Template
        </a>
        <b-alert v-if="importError" show variant="danger">{{ importError }}</b-alert>
        <div class="d-flex justify-content-end">
          <b-button variant="secondary" class="mr-2" @click="showImportModal = false">Batal</b-button>
          <b-button variant="primary" :disabled="!importFile || isImporting" @click="importKoordinat">
            {{ isImporting ? 'Memproses...' : 'Import' }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <div class="d-flex justify-content-between">
      <b-button variant="secondary" @click="$emit('kembali')">Kembali</b-button>
      <div>
        <b-button variant="success" class="mr-2" @click="$emit('simpan')">Simpan</b-button>
        <b-button variant="primary" @click="$emit('selanjutnya')">Selanjutnya</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as XLSX from 'xlsx'
import vSelect from 'vue-select'

export default {
  name: 'FormIdentitasPusat',
  components: { vSelect },
  props: {
    value: {
      type: Object,
      default: () => ({
        nomor_kkprl: '',
        npwp: '',
        subjek_hukum: '',
        nib: '',
        provinsi: '',
        tanggal_terbit: '',
        nama_kegiatan: '',
        nama_detail_kegiatan: '',
        luas: '',
        panjang: '',
        nama_perairan: '',
        nama_kawasan_rtr: '',
        dasar_hukum_rtr: '',
        realisasi_pemanfaatan_ruang_laut: '',
        keterangan_realisasi: '',
        bukti_dukung: null,
        titik_koordinat: [],
      }),
    },
  },
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian') || '{}'),
      provinsiOptions: [],
      isLoadingProvinsi: false,
      provinsiError: '',
      nextPointId: 1,
      showImportModal: false,
      importFile: null,
      importError: '',
      isImporting: false,
      observasiOptions: [
        { text: 'Sesuai', value: 'Sesuai' },
        { text: 'Tidak Sesuai', value: 'Tidak Sesuai' },
      ],
      fields: [
        { key: 'nomor', label: 'Nomor' },
        { key: 'bujur', label: 'Bujur' },
        { key: 'lintang', label: 'Lintang' },
        { key: 'observasi', label: 'Observasi Titik Pengendalian' },
        { key: 'aksi', label: 'Aksi' },
      ],
    }
  },
  computed: {
    itemsWithNumber() {
      return this.value.titik_koordinat.map((point, index) => ({ ...point, nomor: index + 1 }))
    },
  },
  mounted() {
    this.nextPointId =
      this.value.titik_koordinat.reduce((maxId, point) => Math.max(maxId, Number(point.id) || 0), 0) + 1
    this.getProvinsi()
  },
  methods: {
    updateField(field, fieldValue) {
      this.$emit('input', { ...this.value, [field]: fieldValue })
    },
    tambahTitik() {
      const point = {
        id: this.nextPointId++,
        bujur: '',
        lintang: '',
        observasi: '',
      }
      this.$emit('input', { ...this.value, titik_koordinat: [...this.value.titik_koordinat, point] })
    },
    updatePoint(pointId, field, fieldValue) {
      const points = this.value.titik_koordinat.map((point) =>
        point.id === pointId ? { ...point, [field]: fieldValue } : point,
      )
      this.$emit('input', { ...this.value, titik_koordinat: points })
    },
    hapusTitik(pointId) {
      const points = this.value.titik_koordinat.filter((point) => point.id !== pointId)
      this.$emit('input', { ...this.value, titik_koordinat: points })
    },
    resetImport() {
      this.importFile = null
      this.importError = ''
      this.isImporting = false
    },
    async importKoordinat() {
      if (!this.importFile) {
        this.importError = 'Pilih file Excel terlebih dahulu.'
        return
      }

      this.isImporting = true
      this.importError = ''
      try {
        const fileBuffer = await this.importFile.arrayBuffer()
        const workbook = XLSX.read(fileBuffer, { type: 'array' })
        const firstSheetName = workbook.SheetNames[0]
        if (!firstSheetName) {
          throw new Error('File Excel tidak memiliki sheet untuk dibaca.')
        }

        const worksheetRows = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheetName], { header: 1, defval: '' })
        if (worksheetRows.length < 2) {
          throw new Error('Tidak ada baris data pada file Excel.')
        }

        const headerMap = this.getCoordinateHeaderMap(worksheetRows[0])
        if (headerMap.bujur === -1 || headerMap.lintang === -1 || headerMap.observasi === -1) {
          throw new Error('Header wajib: Bujur, Lintang, dan Observasi Titik Pengendalian.')
        }

        const points = []
        worksheetRows.slice(1).forEach((row, index) => {
          const bujur = String(row[headerMap.bujur] || '').trim()
          const lintang = String(row[headerMap.lintang] || '').trim()
          const observasi = String(row[headerMap.observasi] || '').trim()
          if (!bujur && !lintang && !observasi) return

          if (!bujur || !lintang || !['Sesuai', 'Tidak Sesuai'].includes(observasi)) {
            throw new Error(
              `Data baris ${
                index + 2
              } tidak valid. Pastikan Bujur, Lintang, dan nilai observasi (Sesuai/Tidak Sesuai) terisi.`,
            )
          }

          points.push({
            id: this.nextPointId + points.length,
            bujur,
            lintang,
            observasi,
          })
        })

        if (points.length === 0) {
          throw new Error('Tidak ditemukan baris koordinat yang dapat diimpor.')
        }

        this.nextPointId += points.length
        this.$emit('input', {
          ...this.value,
          titik_koordinat: [...this.value.titik_koordinat, ...points],
        })
        this.showImportModal = false
      } catch (error) {
        this.importError = error.message || 'File Excel gagal dibaca.'
      } finally {
        this.isImporting = false
      }
    },
    getCoordinateHeaderMap(headerRow) {
      const normalizeHeader = (value) =>
        String(value)
          .toLowerCase()
          .replace(/[^a-z0-9]/g, '')
      const findHeader = (candidates) =>
        headerRow.findIndex((header) => candidates.some((candidate) => normalizeHeader(header).startsWith(candidate)))
      return {
        nomor: findHeader(['no', 'nomor']),
        bujur: findHeader(['bujur', 'longitude', 'long', 'lon']),
        lintang: findHeader(['lintang', 'latitude', 'lat']),
        observasi: findHeader(['observasititikpengendalian', 'observasi', 'hasiltitikpengendalian']),
      }
    },
    async getProvinsi() {
      this.isLoadingProvinsi = true
      this.provinsiError = ''
      try {
        const response = await axios.get(this.baseapiPengendalian + 'api/provinsi?sort=id,ASC&limit=0', {
          headers: { Authorization: `Bearer ${this.user.accessToken}` },
        })
        this.provinsiOptions = response.data.data || []
      } catch (error) {
        this.provinsiError = 'Daftar provinsi gagal dimuat.'
      } finally {
        this.isLoadingProvinsi = false
      }
    },
  },
}
</script>
